import { createContext } from 'react';

const LoggedUserContext = createContext(null);

export default LoggedUserContext;
